module.exports = __webpack_public_path__ + "img/version-contract-disabled.43fcc7c5.svg";